import {
  CARD_FILL_TYPE_OPTIONS,
  CARD_ORIENTATION_OPTIONS,
  CONTAINER_OPTIONS,
  CONTENT_LAYOUT_OPTIONS,
  CTA_TYPE_OPTIONS,
  HEADING_ALIGNMENT_OPTIONS,
  IMAGE_ASPECT_RATIO_OPTIONS,
  MODULE_FILL_TYPE_OPTIONS,
  MODULE_FLOW_DIRECTION_OPTIONS,
  TITLE_SIZE_OPTIONS,
  TITLE_TYPE_OPTIONS,
} from '@/common/constants';
import { useModuleStyles } from '@/common/hooks';
import { BaseModuleProps } from '@/common/types';
import { CardGroup, CardGroupProps } from '@/components/blocks/CardGroup';
import { HeadingBlock, HeadingBlockProps } from '@/components/blocks/HeadingBlock/HeadingBlock';
import React from 'react';
import styles from './BlogCTA.module.scss';

export interface BlogCTAProps extends BaseModuleProps, CardGroupProps {}

export const BlogCTA: React.FC<BlogCTAProps> = ({
  anchorTag = undefined,
  container = CONTAINER_OPTIONS.CONTAINED,
  fillType = MODULE_FILL_TYPE_OPTIONS.BASE,
  layout = CONTENT_LAYOUT_OPTIONS.CONTENT_TRAILING,
  eyebrow,
  gradientFillToken,
  title,
  titleSize = TITLE_SIZE_OPTIONS.LARGE,
  titleType = TITLE_TYPE_OPTIONS.H2,
  bodyRichTextAsHTML,
  alignment = HEADING_ALIGNMENT_OPTIONS.START,
  ctas,
  caption,
  cardsImageAspectRatio = IMAGE_ASPECT_RATIO_OPTIONS.LANDSCAPE,
  cardsFillType = CARD_FILL_TYPE_OPTIONS.UNCONTAINED,
  cardsCtaType = CTA_TYPE_OPTIONS.INLINE,
  cardsOrientation = CARD_ORIENTATION_OPTIONS.VERTICAL,
  cards,
}) => {
  const headingConfig: HeadingBlockProps = {
    eyebrow,
    title,
    titleSize,
    titleType,
    bodyRichTextAsHTML,
    alignment,
    ctas,
    caption,
  };

  const cardGroupConfig: CardGroupProps = {
    showCardImage: true,
    showCardBadge: true,
    showCardCTA: true,
    cardsImageAspectRatio,
    cardsFillType,
    cardsCtaType,
    cardsOrientation,
    cards,
  };

  // Use the common module styles hook
  const { sectionStyles, moduleBaseStyles } = useModuleStyles({
    container,
    fillType,
    layout,
    gradientFillToken,
    flowDirection: MODULE_FLOW_DIRECTION_OPTIONS.COLUMN,
    moduleClassName: 'module-blog-cta',
    styles,
  });

  return (
    <section className={sectionStyles} id={anchorTag}>
      <div className={moduleBaseStyles}>
        <HeadingBlock {...headingConfig} />
        <CardGroup {...cardGroupConfig} />
      </div>
    </section>
  );
};
